module.exports = __webpack_public_path__ + "img/icon-payout-success.4ecfb68c.svg";